import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";

export default function ContentManager() {
  const navigate = useNavigate();

  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;

  const channelId = user?.channelId;
  const userId = user?._id;

  const [content, setContent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(1);

  /* ================= FETCH ================= */
  const fetchContent = async () => {
    try {
      setLoading(true);
      let res;

      /* ===== VIDEOS / SHORTS ===== */
      if (activeTab === 1 || activeTab === 2) {
        res = await api.get("/client/video/videosOfChannel", {
          params: {
            userId,
            channelId,
            videoType: activeTab,
            start: 1,
            limit: 50,
          },
        });

        setContent(
          res?.data?.status
            ? res.data.videosTypeWiseOfChannel
            : []
        );
      }

      /* ===== POSTS ===== */
      if (activeTab === 3) {
        res = await api.get("/api/posts/channel-posts", {
          params: { channelId },
        });

        setContent(
          res?.data?.status
            ? res.data.postsOfChannel
            : []
        );
      }

      /* ===== SONGS ===== */
      if (activeTab === 4) {
        res = await api.get("/client/song/songsOfChannel", {
          params: { channelId },
        });

        setContent(
          res?.data?.status
            ? res.data.songs
            : []
        );
      }

    } catch (err) {
      console.error("Content load error:", err);
      setContent([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId && channelId) fetchContent();
  }, [activeTab, userId, channelId]);

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    try {
      if (!window.confirm("Are you sure you want to delete this?")) return;

      /* ===== POST DELETE ===== */
      if (activeTab === 3) {
        await api.delete(`/api/posts/${id}`, {
          data: { userId },
        });
      }

      /* ===== VIDEO / SHORT DELETE ===== */
      else if (activeTab === 1 || activeTab === 2) {
        await api.delete("/client/video/deleteVideoRecord", {
          params: { videoId: id },
        });
      }

      /* ===== SONG DELETE ===== */
      else if (activeTab === 4) {
        await api.delete("/client/song/deleteSong", {
          data: {
            songId: id,
            userId,
          },
        });
      }

      fetchContent();

    } catch (error) {
      console.error("Delete failed:", error);
      alert("Delete failed");
    }
  };

  /* ================= VIEW ROUTE ================= */
  const handleView = (item) => {
    if (activeTab === 1) {
      navigate(`/user/video/${item._id}`);
    } else if (activeTab === 2) {
      navigate(`/user/shorts/${item._id}`);
    } else if (activeTab === 3) {
      navigate(`/user/post/${item._id}`);
    } else if (activeTab === 4) {
      navigate(`/user/song/${item._id}`);
    }
  };

  /* ================= EDIT ROUTE ================= */
  const handleEdit = (item) => {
    if (activeTab === 1) {
      navigate(`/user/edit-video/${item._id}?type=1`);
    } else if (activeTab === 2) {
      navigate(`/user/edit-video/${item._id}?type=2`);
    } else if (activeTab === 3) {
      navigate(`/user/edit-post/${item._id}`);
    } else if (activeTab === 4) {
      navigate(`/user/edit-song/${item._id}`);
    }
  };

  return (
    <div className="content-manager">
      <h2 className="section-title">Content Manager</h2>

      {/* ================= TABS ================= */}
      <div className="content-tabs">
        <button
          className={activeTab === 1 ? "tab-btn active" : "tab-btn"}
          onClick={() => setActiveTab(1)}
        >
          Videos
        </button>

        <button
          className={activeTab === 2 ? "tab-btn active" : "tab-btn"}
          onClick={() => setActiveTab(2)}
        >
          Shorts
        </button>

        <button
          className={activeTab === 3 ? "tab-btn active" : "tab-btn"}
          onClick={() => setActiveTab(3)}
        >
          Posts
        </button>

        <button
          className={activeTab === 4 ? "tab-btn active" : "tab-btn"}
          onClick={() => setActiveTab(4)}
        >
          Songs
        </button>
      </div>

      {loading ? (
        <p className="panel-loading">Loading...</p>
      ) : content.length === 0 ? (
        <div className="empty-box">
          <p>No content found</p>
        </div>
      ) : (
        <div className="content-grid">
          {content.map((item) => (
            <div key={item._id} className="content-card">

              <img
                src={
                  activeTab === 3
                    ? item.mediaUrl || item.media?.url
                    : activeTab === 4
                    ? item.thumbnailUrl
                    : item.videoImage
                }
                alt={item.title || item.caption}
                className="content-thumb"
              />

              <div className="content-info">
                <h4>{item.title || item.caption}</h4>

                <span>
                  {activeTab === 3
                    ? `${item.viewsCount || 0} views`
                    : activeTab === 4
                    ? `${item.totalPlays || 0} plays`
                    : `${item.views || 0} views`}
                </span>
              </div>

              <div className="content-actions">
                <button
                  className="secondary-btn"
                  onClick={() => handleView(item)}
                >
                  View
                </button>

                <button
                  className="secondary-btn"
                  onClick={() => handleEdit(item)}
                >
                  Edit
                </button>

                <button
                  className="danger-btn"
                  onClick={() => handleDelete(item._id)}
                >
                  Delete
                </button>
              </div>

            </div>
          ))}
        </div>
      )}
    </div>
  );
}